import {createAsyncThunk} from "@reduxjs/toolkit";
import api from "../../utils/axios";

// Thunks

// Fetch tickets thunk
export const fetchTickets = createAsyncThunk(
    "tickets/fetchTickets",
    async () => {
        const response = await api.get("/tickets");
        return response.data;
    }  
);


// Create ticket thunk
export const createTicket = createAsyncThunk(
    "tickets/createTicket",
    async (ticketData) => { 
        const response = await api.post("/tickets", ticketData);
        return response.data;
    }   
);

// Update ticket thunk
export const updateTickets = createAsyncThunk(
    "tickets/updateTickets",
    async ({id, updatedData}) => {
        const response = await api.put(`/tickets/${id}`, updatedData);
        return response.data;
    }       
);

// Delete ticket thunk
export const deleteTicket = createAsyncThunk(
    "tickets/deleteTicket",
    async (id) => {
        await api.delete(`/tickets/${id}`);
        return id;
    }       
);



